export default {
  errorNotAnImage: 'Preview not possible, the file is not an image or is no longer available.',
};
